import React, { Fragment } from "react";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import CustomTableEmptyRecord from "../common/CustomTableEmptyRecord";
import CustomTableHeader from "../common/CustomTableHeader";

//Table Columns
const tableColumns = [
  { title: "Document Name" },
  { title: "Description" },
  { title: "Document URL" },
];

const View = (props) => {
  const { viewToggle, viewModal, data } = props;

  const closeBtn = (
    <button type="button" className="btn-close" onClick={viewToggle} aria-label="Close"></button>
  );

  return (
    <Fragment>
      <Modal
        isOpen={viewModal}
        toggle={viewToggle}
        style={{ maxWidth: "800px" }}
        backdrop="static"
      >
        <ModalHeader toggle={viewToggle} close={closeBtn}>
          Additional Document Details
        </ModalHeader>
        <ModalBody>
          <Table responsive hover>
            {/* Table Header */}
            <CustomTableHeader tableColumns={tableColumns} />
            {/* Table Header */}
            <tbody>
              <Fragment>
                {!data.length ? (
                  //  Empty Record
                  <CustomTableEmptyRecord columnsCount={tableColumns.length} />
                ) : (
                  //  Empty Record
                  <Fragment>
                    {data.map((record, key) => (
                      <tr key={`docs_list_${key}`}>
                        <td style={{ width: "200px" }}>
                          {record.documentName}
                        </td>
                        <td>{record.description}‎</td>
                        <td style={{ width: "150px" }}>
                          <a href={record.documentURL} target="_blank">
                            <Button className="action-btn" color="success">
                              <span className="fas fa-file"></span>
                            </Button>
                            ‎
                          </a>
                          {!!record.isRequired && (
                            <i
                              title="Required Document"
                              className="fas fa-exclamation-circle"
                              style={{ color: "#c72e39", marginLeft: "8px" }}
                            ></i>
                          )}
                        </td>
                      </tr>
                    ))}
                  </Fragment>
                )}
              </Fragment>
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={viewToggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default View;
